import React from 'react';
import S from "./PrivacyPolicy.module.scss";
import {Anchor, Breadcrumbs} from "@mantine/core";
import {useNavigate} from "react-router-dom";

export const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const items = [
    { title: 'Главная', url: '/' },
    { title: 'О компании', url: '/about-company' },
    { title: 'Политика конфиденциальности', active: true },
  ].map((item, index) => (
    <Anchor onClick={() => item.url && navigate(item.url)} key={index} data-active={item.active || undefined}>
      {item.title}
    </Anchor>
  ));

  return (
    <section id='policy'>
      <div className={S.policy}>
        <div className={S.policy_content}>
          <Breadcrumbs>
            {items}
          </Breadcrumbs>
          <h1>Политика конфиденциальности</h1>
          <div className={S.policy_text}>
            Я, заполняя форму на сайте evoforum.ru, даю свое согласие администратору сайта evoforum.ru, в соответствии с
            Федеральным законом от 27.07.2006 152-ФЗ «О персональных данных», на обработку, хранение и передачу третьим
            лицам через Интернет моих персональных данных. Я подтверждаю, что, даю такое согласие, действуя по своей
            воле и в своем интересе. Целью предоставления мною персональных данных является установление связи с
            администратором сайта evoforum.ru, включая направление уведомлений, запросов, касающихся использования
            сайта, оказания услуг. Настоящим, я признаю и подтверждаю, что я самостоятельно и полностью несу
            ответственность за предоставленные мною персональные данные, включая их полноту, достоверность,
            недвусмысленность и относимость непосредственно ко мне. Я подтверждаю, что ознакомлен с правами и
            обязанностями, в соответствии с Федеральным законом «О персональных данных», в т.ч. порядком отзыва согласия
            на сбор и обработку персональных данных.
          </div>
        </div>
      </div>
    </section>
  );
}